import { useEffect, useState } from 'react';

const API = import.meta.env.VITE_API_URL;

export default function Payments() {
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/affiliate-portal/payments`, { credentials: 'include' })
      .then((r) => r.json() as Promise<{ success: boolean; data: any[] }>)
      .then((j) => { if (j.success) setPayments(j.data); setLoading(false); });
  }, []);

  if (loading) return <div className="text-center text-slate-500 dark:text-slate-400 py-8">Loading...</div>;

  const total = payments.reduce((s, p) => s + Number(p.amount || 0), 0);

  return (
    <div>
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">Payment History</h2>
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-6">
        All payments received from the OAK affiliate program. Total received to date: <strong>${total.toFixed(2)}</strong>.
      </p>

      {payments.length === 0 ? (
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm p-6 text-center text-slate-500 dark:text-slate-400">
          No payments yet. Once your commissions are paid, they'll show up here.
        </div>
      ) : (
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 dark:bg-slate-800">
              <tr>
                <th className="text-left p-3">Paid On</th>
                <th className="text-left p-3">Method</th>
                <th className="text-right p-3">Amount</th>
                <th className="text-left p-3">Reference</th>
                <th className="text-left p-3">Notes</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.id} className="border-b">
                  <td className="p-3">{new Date(p.paid_at).toLocaleDateString()}</td>
                  <td className="p-3 text-xs uppercase">{p.method.replace('_', ' ')}</td>
                  <td className="p-3 text-right font-mono font-bold">${Number(p.amount).toFixed(2)}</td>
                  <td className="p-3 text-xs font-mono">{p.reference_number || '—'}</td>
                  <td className="p-3 text-xs text-slate-600 dark:text-slate-300">{p.notes || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
